import React from "react";
import fb from "../../lib/firebase";
import {EntityList} from "../../components/EntityListNG";
import FormAnexo from "../Anexos/FormAnexo";
import {PathDescription} from "../../models/Core";
import {AnexoObject} from "../../models/Anexo";
import {FazendaObject} from "../../models/Fazenda";
import moment from "moment";
import truncate from "lodash/truncate";
import {acervo, AcervoItem} from "../../lib/acervo";
import {IonProgressBar, IonBadge} from "@ionic/react";
import {filtrarColecao, sanitizeText} from "../../lib/utils";
import {AppState} from "../../models/app";
import {AppDispatch, RootState} from "../../global.state";
import {connect} from "react-redux";
import {actions} from "../../lib/app";

interface Props {
  app: AppState;
  dispatch: AppDispatch;
  instance: FazendaObject;
  history: any;
}

interface State {
  loading: boolean;
  colecao: any[];
  colecaoFiltrada: any[];
}

class _AbaAnexos extends React.Component<Props, State> {
  private cancelListener: () => void;

  constructor(props:Props) {
    super(props);

    this.state = {
      loading: false,
      colecao: [],
      colecaoFiltrada: [],
    };

    this.cancelListener = () => {};
  }

  componentDidMount() {
    this.installListener();
  }

  componentWillUnmount() {
    this.cancelListener();
  }

  installListener = () => {
    this.setState({loading: true});
    const query = fb.db.collection('anexos')
      .where('owner', '==', this.props.app.user.uid)
      .where('principal.path', '==', fb.db.collection('fazendas').doc(this.props.instance.id))
      .orderBy("data", "desc")

    this.cancelListener = query.onSnapshot(snap => {
      const colecao = fb.col(snap);
      this.setState({colecao, loading: false});
      this.filtrarColecao();
    });
  };

  filtrarColecao = (criterio:string='') => {
    this.setState({
      colecaoFiltrada: filtrarColecao(this.state.colecao, criterio, 'descricao')
    });
  }

  onClickInstance = (instance: AnexoObject) => {
    this.props.dispatch(actions.jump(`/fazendas/${this.props.instance.id}/anexos`));
    this.props.history.push(`/anexos/${instance.id}/home`);
  };

  cardSubtitle = (i: AnexoObject) => (
    <>
      {moment(i.data.toDate()).format('DD/MM/YYYY HH:mm')}
    </>
  );

  cardTitle = (i: AnexoObject) => (
    <>
      <div>{i.descricao}</div>
      {i.name &&
        <div className="text-xs opacity-50">
          {i.name}
        </div>
      }
    </>
  );

  cardContent = (i: AnexoObject) => {
    return <AnexoCard anexo={i} />
  };

  render() {
    return (
      <EntityList
        entityLabel="anexo"
        colecao={this.state.colecaoFiltrada}
        loading={this.state.loading}
        filtrarColecao={this.filtrarColecao}
        addEnabled={true}
        onClickInstance={this.onClickInstance}
        cardSubTitle={this.cardSubtitle}
        cardTitle={this.cardTitle}
        cardContent={this.cardContent}
        ModelForm={FormAnexo}
        modelFormProps={{
          principal: {
            collection: 'fazendas',
            id: this.props.instance.id,
            label: `Fazenda: ${this.props.instance.nome} (${this.props.instance.tipo.join(', ')})`,
          } as PathDescription
        }}
      />
    );
  }
}


interface AnexoCardProps {
  anexo: AnexoObject;
}

interface AnexoCardState {
  item: AcervoItem | undefined;
  progress: number;
  error: string;
}

class AnexoCard extends React.Component<AnexoCardProps, AnexoCardState> {
  constructor(props: AnexoCardProps) {
    super(props);

    this.state = {
      item: undefined,
      progress: 0,
      error: '',
    };
  }

  componentDidMount() {
    acervo.item(this.props.anexo.uuid).then(item => {
      if (item) {
        // disparar upload se necessário
        if (!item.uploaded && !item.uploading && !item.errorUploading) {
          acervo.upload(item, progress => {
              this.setState({progress});
            },
            error => {
              console.log(`ERRO UPLOADING: ${error}\n${item}`);
              acervo.item(item.uuid).then(i => {
                if (i)
                  this.setState({item: i, error});
              });
            },
            () => {
              acervo.item(item.uuid).then(i => {
                if (i)
                  this.setState({item: i});
              });
            });
        }

        if (item.errorUploading)
          this.setState({error: item.error});

        this.setState({item});
      }
    })
  }

  render() {
    const {item} = this.state;

    return (
      <>
        <div>
          {truncate(sanitizeText(this.props.anexo.notas), {length: 100})}
          {
            item && !item.uploaded && !item.uploading && !item.errorUploading &&
              <IonProgressBar value={this.state.progress}/>
          }

          {
            item && this.state.error && item.errorUploading &&
              <IonBadge color="danger">Erro</IonBadge>
          }
        </div>
      </>
    );
  }
}
export const AbaAnexos = connect(({app}: RootState) => ({app}))(_AbaAnexos);